/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class LocationIcon extends BaseIcon {
  getChildren = () => [ <path
    fill={ this.getColor() }
    transform="translate(5.000000, 0.000000)"
    d="M11.4285714,0 C5.02857143,0 0,5.02857143 0,11.2 C0,19.6571429 11.4285714,32 11.4285714,32 C11.4285714,32 22.8571429,19.6571429 22.8571429,11.2 C22.8571429,5.02857143 17.8285714,0 11.4285714,0 Z M11.4285714,16 C8.91428571,16 6.85714286,13.9428571 6.85714286,11.4285714 C6.85714286,8.91428571 8.91428571,6.85714286 11.4285714,6.85714286 C13.9428571,6.85714286 16,8.91428571 16,11.4285714 C16,13.9428571 13.9428571,16 11.4285714,16 Z"/> ]
  getViewBox = () => '0 0 32 32'
}
